import api from '@/api';

class Organisation {
  /**
   * @returns {AxiosPromise<any>}
   */
  static get() {
    return api.get('/teams/organisation');
  }
}

export default Organisation;
